import { withSvgIcon } from './withSvgIcon';

export const Code = withSvgIcon(
  <>
    <path
      d="M8.22 21H15.78C16.919 21 17.4885 21 17.9219 20.7748C18.2872 20.5851 18.5851 20.2872 18.7748 19.9219C19 19.4885 19 18.919 19 17.78V8L14 3H8.22C7.08102 3 6.51153 3 6.07805 3.22517C5.71276 3.41492 5.41492 3.71276 5.22517 4.07805C5 4.51153 5 5.08102 5 6.22V17.78C5 18.919 5 19.4885 5.22517 19.9219C5.41492 20.2872 5.71276 20.5851 6.07805 20.7748C6.51153 21 7.08102 21 8.22 21Z"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M11 8L8 11L11 14"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M13 11L16 14L13 17"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
